import React from "react";
import { OptionsGroup } from "@components/UI/Inputs/SelectInput/types";
import { Generation, Model } from "@app/store/types";
import { CURRENT_YEAR, START_YEAR_PRODUCTION } from "@shared/config/Date";
import { numberToRoman } from "@shared/lib/utils";
import { SelectOption } from "../types";

export const useFormattedOptions = (
    brandsOptions: SelectOption[] | undefined,
    modelOptions: SelectOption[] | undefined,
    generationsOptions: Generation[] | undefined,
    modelValue: Model | undefined,
    modelOptionsIsFetching: boolean,
    isFetchingGenerations: boolean
) => {
    const brandsOptionsFormatted: OptionsGroup[] = React.useMemo(
        () =>
            brandsOptions
                ? [
                      {
                          label: "Все",
                          options: brandsOptions.map((brand: SelectOption) => ({
                              value: brand.id,
                              label: brand.name,
                              alias: brand.alias
                          }))
                      }
                  ]
                : [],
        [brandsOptions]
    );

    const modelFormattedOptions: OptionsGroup[] = React.useMemo(() => {
        if (modelOptionsIsFetching) {
            return [];
        } else if (modelOptions && modelOptions.length > 0) {
            return [
                {
                    label: "Все",
                    options: modelOptions.map((model: SelectOption) => ({
                        value: model.id,
                        label: model.name,
                        alias: model.alias
                    }))
                }
            ];
        }
        return [];
    }, [modelOptions, modelOptionsIsFetching]);

    const generationFormattedOptions: OptionsGroup[] = React.useMemo(() => {
        if (isFetchingGenerations) {
            return [];
        } else if (generationsOptions && generationsOptions.length > 0) {
            const options = generationsOptions.map((gen: Generation) => {
                const { id, name, generation, restyleNumber, startedAt, endedAt } = gen;

                const validStartedAt =
                    startedAt !== undefined && startedAt >= START_YEAR_PRODUCTION
                        ? startedAt
                        : undefined;
                const validEndedAt =
                    endedAt !== undefined && endedAt >= START_YEAR_PRODUCTION
                        ? endedAt
                        : CURRENT_YEAR;

                const period = validStartedAt ? `${validStartedAt} - ${validEndedAt}` : "";
                const generationNum = generation ? numberToRoman(generation) : "";
                const restyle = (restyleNumber || 0) > 0 ? `${restyleNumber} Рестайлинг` : "";

                const parts = [
                    period,
                    generationNum ? `${generationNum}` : "",
                    name ? `${name}` : "",
                    restyle
                ]
                    .filter((part) => part)
                    .join(" ");

                const genUriId = `${modelValue?.id}10${restyleNumber || 0}`;
                return {
                    value: id,
                    label: parts.trim(),
                    generation,
                    modelValue,
                    restyleNumber,
                    pic: `${process.env.NEXT_PUBLIC_YANDEX_STORAGE_URL}/generations/${genUriId}.webp`
                };
            });

            return [
                {
                    label: "Все",
                    options
                }
            ];
        }
        return [];
    }, [generationsOptions, isFetchingGenerations, modelValue]);

    return {
        brandsOptionsFormatted,
        modelFormattedOptions,
        generationFormattedOptions
    };
};